import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import Api from '~/api'
import moment from 'moment'

export default class Files extends Component {
  state = {
    loading: false,
    folders: false,
  }

  componentDidMount = () => {
    let { organization } = this.props
    let { loading, folders } = this.state

    if (loading || Map.isMap(folders)) return this.setState({ open: true })

    this.setState({
      loading: true,
    })

    Api.get(`/organization/${organization.get('id')}/files`)
      .then(({ data }) => {
        if (data.success)
          return this.setState({
            folders: fromJS(data.folders),
            loading: false,
          })

        this.setState({
          error: true,
        })
      })
      .catch(err => {
        console.log(err.message)
        this.setState({
          error: true,
        })
      })
  }

  getSignedUrl = file_id => {
    let { organization } = this.props

    Api.get(`/organization/${organization.get('id')}/files/${file_id}`).then(({ data }) => {
      if (data.success) {
        let a = document.createElement('a')
        a.download = true
        a.href = data.file.url
        a.click()
      }
    })
  }

  render() {
    let { loading, folders, error } = this.state

    if (!List.isList(folders)) folders = List()

    return (
      <div className="files">
        {loading ? (
          error ? (
            <div>Tiedostoja ei pystytty lataamaan</div>
          ) : (
            <div>Ladataan..</div>
          )
        ) : (
          <div>
            <table className="files-table ui selectable table">
              <thead>
                <tr>
                  <th>Tiedosto</th>
                  <th>Päivitetty</th>
                </tr>
              </thead>
              <tbody>
                {folders.map(folder => {
                  if (!Map.isMap(folder)) folder = Map()
                  let materials = folder.get('materials', List())

                  return (
                    <Fragment key={folder.get('id')}>
                      <tr>
                        <td>{folder.get('label')}</td>
                        <td>
                          {moment(folder.get('delivered_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
                        </td>
                      </tr>
                      {materials.map(file => {
                        return (
                          <tr key={file.get('id')}>
                            <td>
                              {file.getIn(['file', 'access']) === 'private' ? (
                                <button
                                  className="button-plain"
                                  onClick={e => e.preventDefault() & this.getSignedUrl(file.getIn(['file', 'id']))}>
                                  {file.getIn(['file', 'filename'])}
                                </button>
                              ) : (
                                <a href={file.getIn(['file', 'url'])} target="_blank">
                                  {file.getIn(['file', 'filename'])}
                                </a>
                              )}
                            </td>
                            <td>
                              {moment(file.getIn(['file', 'updated_at']), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format(
                                'DD.MM.YYYY - HH:mm'
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </Fragment>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    )
  }
}
